import { type Auth } from '@atlaskit/media-core';

import { MediaStoreError } from './MediaStoreError';

export const resolveInitialAuth = (auth?: Auth): Auth => {
	if (!auth) {
		throw new MediaStoreError('missingInitialAuth');
	}
	return auth;
};
